import LaporanGeneralMarketing from './LaporanGeneralMarketing'

export default LaporanGeneralMarketing